'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function uniqueValues(array) {
  return Array.from(new Set(array).values());
}
function arrayDiff(arr, arr2) {
  return arr.filter((i) => arr2.indexOf(i) < 0);
}
function shuffle(arr) {
  const array = arr.slice();
  let m = array.length;
  let t;
  let i;
  while (m) {
    i = Math.floor(Math.random() * m--);
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}
function groupBy(arr, key) {
  const map = new Map();
  arr.forEach((item) => {
    const collection = map.get(key);
    if (!collection) {
      map.set(item[key], [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map.values()).reduce((acc, curr) => {
    acc.push(curr.reduce((merged, latest) => {
      for (const subKey of Object.keys(latest)) {
        const value = latest[subKey];
        if (value) {
          merged[subKey] = value;
        }
      }
      return merged;
    }, Object.assign({}, curr[0])));
    return acc;
  }, []);
}

exports.arrayDiff = arrayDiff;
exports.groupBy = groupBy;
exports.shuffle = shuffle;
exports.uniqueValues = uniqueValues;
